// extracted by mini-css-extract-plugin
export default {"products":"Kv-z","card":"Lv-z","oosMessaging":"Mv-z"};